import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { useTranslation } from "react-i18next";

import { Box, Typography, ButtonGroup, IconButton, Tooltip } from "@mui/material";
import Iconify from "src/components/iconify";
import HiddeableComponent from "src/consuman-components/generic/hiddeable-component";

const ItemsSelectedHandler = React.forwardRef(
  ({ selectedItems, children, onClearSelected }, ref) => {
    const [data, setData] = useState(selectedItems);
    const { t } = useTranslation();
    const multipleButtonsRef = useRef(null);

    const toggleShow = e => {
      setData(e);
    };

    React.useImperativeHandle(ref, () => ({
      toggleShow,
    }));

    useEffect(() => {
      setData(selectedItems);
    }, [selectedItems, setData]);

    return (
      <>
        {data ? (
          <HiddeableComponent
            ref={multipleButtonsRef}
            newData={data}
            component={e => (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: 1,
                  bgcolor: "background.paper",
                  borderRadius: 2,
                  px: 2,
                  py: 0.5,
                }}
              >
                <Typography variant="subtitle1">{t("selectedItems", { count: e })}</Typography>

                {/* flexShrink: 0 — the toolbar squeezing this strip must not cut the action buttons. */}
                <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                  <Tooltip title={t("clearSelection")}>
                    <IconButton
                      onClick={onClearSelected}
                      variant="soft"
                      color="error"
                      sx={{ mr: 1 }}
                    >
                      <Iconify icon="mdi:cross-circle-outline" />
                    </IconButton>
                  </Tooltip>
                  <ButtonGroup variant="soft">{children && children()}</ButtonGroup>
                </Box>
              </Box>
            )}
          />
        ) : null}
      </>
    );
  }
);

ItemsSelectedHandler.propTypes = {
  selectedItems: PropTypes.number,
  children: PropTypes.any,
  onClearSelected: PropTypes.func,
};

export default ItemsSelectedHandler;
